'use client'

import { useTranslation } from '@shared/config/i18n'
import { sendGA4CustomEvent } from '@shared/libs'
import Image from 'next/image'
import { ComponentProps } from 'react'

type Props = {
  onClickWrapper: () => void
} & Partial<ComponentProps<typeof Image>>

export const HexagonGmiBanner = ({ onClickWrapper, ...props }: Props) => {
  const t = useTranslation()

  const handleClick = () => {
    sendGA4CustomEvent('hexagon_gmi_banner_click', {
      redirect_url: 'https://www.hexagongmi.com/',
    })
    onClickWrapper()
  }

  return (
    <header aria-label="hexagon-gmi-banner">
      <button type="button" onClick={handleClick} className="w-full cursor-pointer border-0 bg-transparent p-0">
        <Image
          src="/images/banners/hexagon-gmi-kmove.png"
          alt={t('homeBanners.alt.hexagonGmiKmove')}
          width={1005}
          height={252}
          className="w-full h-auto"
          {...props}
        />
      </button>
    </header>
  )
}
